// extracted by mini-css-extract-plugin
export default {"line":"LineDivisor_line__05Fvc","theme-default":"LineDivisor_theme-default__j485d","theme-visa":"LineDivisor_theme-visa__4sYDU"};